import { Component, OnInit } from '@angular/core';
import { MaquetaServiceService } from '../../services/maqueta-service.service';
import { Maqueta } from '../../../../_entities/Maqueta/Maqueta';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'kt-maqueta',
	templateUrl: './maqueta.component.html',
	styleUrls: ['./maqueta.component.scss']
})
export class MaquetaComponent implements OnInit {
	public titulo: String = 'Control de Manufactura';
	public listaMaqueta: Maqueta[];
	public interval = null;

	constructor(private maquetaService: MaquetaServiceService, private toast: ToastrService) { }

	ngOnInit() {
		this.obtenerDatosMaqueta();

		this.interval = setInterval(() => {
			this.obtenerDatosMaqueta()
		}, 2000)

	}

	ngOnDestroy() {
			clearInterval(this.interval);
	}

	obtenerDatosMaqueta() {
		this.maquetaService.obtenerMaqueta().subscribe(result => {
			this.listaMaqueta = result;
		}, err => {
			this.toast.error('Error al obtener los datos')
		})
	}

}
